import { cn } from "@/lib/utils";

interface CalcRowProps {
  label: string;
  value: string;
  // The highlighted bottom line (the preview's `.calc-total`).
  isTotal?: boolean;
}

// One "label ..... value" result line in the industry calculators (the
// preview's `.calc-row`).
const CalcRow = ({ label, value, isTotal = false }: CalcRowProps) => (
  <div
    className={cn(
      "flex items-baseline justify-between gap-3 text-base text-ink",
      isTotal
        ? "rounded-[14px] bg-tone-blush px-3.5 py-3"
        : "border-b border-dashed border-line py-2",
    )}
  >
    <span>{label}</span>
    <b
      className={cn(
        "font-bold tabular-nums",
        isTotal ? "text-[28px] text-primary" : "text-[20px]",
      )}
    >
      {value}
    </b>
  </div>
);

export default CalcRow;
